import { FormValidator, ValidationRules } from 'src/utils/FormValidator';

/** Amazon login: lowercase alphanumeric, 2-64 chars. */
const LOGIN_PATTERN = /^[a-z0-9]{2,64}$/;

export const UserFormValidationPaths = {
  ALIAS: {
    path: 'alias',
    message: 'Error: Please enter the alias.',
  },
  ALIAS_FORMAT: {
    path: 'alias',
    message: 'Error: Please select an employee from the suggestions.',
  },
  FULL_NAME: {
    path: 'fullName',
    message: 'Error: Please enter the full name.',
  },
  BUSINESS_UNIT: {
    path: 'businessUnit',
    message: 'Error: Please select a business unit.',
  },
  ROLE: {
    path: 'role',
    message: 'Error: Please select a role.',
  },
} as const;

export const UserFormValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator
    .addRule(
      UserFormValidationPaths.ALIAS.path,
      ValidationRules.required,
      UserFormValidationPaths.ALIAS.message,
    )
    .addRule(
      UserFormValidationPaths.ALIAS_FORMAT.path,
      ValidationRules.custom((value) => LOGIN_PATTERN.test(value ?? '')),
      UserFormValidationPaths.ALIAS_FORMAT.message,
    )
    .addRule(
      UserFormValidationPaths.FULL_NAME.path,
      ValidationRules.required,
      UserFormValidationPaths.FULL_NAME.message,
    )
    .addRule(
      UserFormValidationPaths.BUSINESS_UNIT.path,
      ValidationRules.required,
      UserFormValidationPaths.BUSINESS_UNIT.message,
    )
    .addRule(
      UserFormValidationPaths.ROLE.path,
      ValidationRules.required,
      UserFormValidationPaths.ROLE.message,
    );
  return validator;
};
